import styled from "styled-components";
import { theme } from "../../../../constants/StyledComponents";

export const StyledPotentialMatrixHeader = styled.div`
  & .main-header {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
    align-items: center;
    column-gap: 20px;
    padding: 12px 20px;
    border-bottom: 1px solid ${theme.colors.purple_2};

    & .filters-start-container {
      min-width: 0;
      display: flex;
      align-items: center;
      gap: 20px;
      justify-self: stretch;
    }

    & .select-practice-container,
    & .select-competence-center-container {
      min-width: 0;
      width: 250px;
      max-width: 250px;
    }

    & .switch-container {
      display: flex;
      justify-content: center;
      justify-self: center;
    }

    & .filters-end-container {
      position: relative;
      display: flex;
      align-items: center;
      gap: 12px;
      justify-self: end;
      height: 48px;
    }
  }

  & .sub-header {
    display: flex;
    flex-direction: column;
    padding: 20px;
    padding-bottom: 0px;
    gap: 20px;

    & .title {
      margin-top: 10px;
    }
  }

  & .header-toggle {
    display: flex;
    align-items: center;
    gap: 10px;
  }
`;

export const StyledSearchContainer = styled.div<{ $hidden: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  visibility: ${({ $hidden }) => ($hidden ? "hidden" : "visible")};
  pointer-events: ${({ $hidden }) => ($hidden ? "none" : "auto")};
`;

export const StyledInlineSearchPanel = styled.div<{ $visible: boolean }>`
  position: absolute;
  right: 0;
  top: 0;
  background-color: ${theme.colors.white};
  max-width: ${({ $visible }) => ($visible ? "250px" : "0")};
  transform: ${({ $visible }) => ($visible ? "scaleX(1)" : "scaleX(0)")};
  transform-origin: right center;
  transition:
    max-width 0.3s ease-in-out,
    transform 0.3s ease-in-out,
    opacity 0.3s ease-in-out;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  display: flex;
  align-items: center;
  z-index: 2;

  & > div {
    width: 250px;
    visibility: ${({ $visible }) => ($visible ? "visible" : "hidden")};

    @media (max-width: ${({ theme }) => theme.breakpoints.XL}px) {
      width: 180px;
    }
  }
`;
